<template>
    <div>
        <form autocomplete="off" @submit.prevent="postDatosFiscales()">
            <vs-row class="p-4">
                <vs-col w="12" class="lineTitulo mb-2">
                    <h5><strong>DATOS FISCALES</strong></h5>
                </vs-col>
                <vs-col w="12" class="mb-2">
                    <p>Es fundamental que el receptor proporcione sus datos fiscales exactamente como aparecen en su constancia de situación fiscal más reciente, incluyendo mayúsculas, minúsculas y caracteres especiales. Si no se proporciona esta información, se emitirá una factura genérica a final de mes. Si se ingresan los datos fiscales, la factura se generará con dicha información.</p>
                    <p v-if="userModificacion.name" class="mb-0">Persona que realizó cambios: <strong>{{userModificacion.name}}</strong></p>
                    <p>Fecha de actualización:<strong> {{fecha_hora}}</strong></p>
                </vs-col>
                <vs-col class="inputTitulo" sm="12" lg="4">
                    <label>RFC *</label>
                    <vs-input
                        class="pt-0"
                        v-model="info.rfc"
                        placeholder="RFC"
                        @blur="getRfc(info.rfc)"
                        @input="tranformarMayusculas()"
                    >
                        <template #message-danger>
                            <span v-if="errorFields.includes('rfc')">Requerido</span>
                            <span v-if="rfcCaracteres">El RFC no tiene formato correcto</span>
                        </template>
                    </vs-input>
                </vs-col>
                <vs-col class="inputTitulo" sm="12" lg="4">
                    <label>Razón social *</label>
                    <vs-input
                        class="pt-0"
                        v-model="info.razon_social"
                        placeholder="Razón social"
                    >
                        <template #message-danger v-if="errorFields.includes('razon_social')">
                            Requerido
                        </template>
                    </vs-input>
                </vs-col>
                <vs-col class="inputTitulo" sm="12" lg="4">
                    <label>Correo fiscal *</label>
                    <vs-input
                        type="email"
                        class="pt-0"
                        v-model="info.correo_fiscal"
                        placeholder="Correo fiscal"
                    >
                        <template #message-danger v-if="errorFields.includes('correo_fiscal')">
                            Requerido
                        </template>
                    </vs-input>
                </vs-col>
                <vs-col class="inputTitulo" sm="12" lg="4">
                    <label>Régimen fiscal *</label>
                    <vs-select
                        filter
                        class="pt-0"
                        placeholder="Régimen fiscal" 
                        v-model="info.regimen_fiscal"
                        :key="regimenId" 
                    >
                        <vs-option v-for="(regimen, i) in regimenes" :key="i" :label="regimen.text" :value="regimen.id">
                            {{regimen.text}}
                        </vs-option>
                        <template #message-danger v-if="errorFields.includes('regimen_fiscal')">
                            Requerido
                        </template>
                    </vs-select>
                </vs-col>
                <vs-col class="inputTitulo" sm="12" lg="4">
                    <label>C.P. *</label>
                    <vs-input
                        class="pt-0"
                        v-model="info.codigo_postal"
                        placeholder="C.P."
                    >
                        <template #message-danger v-if="errorFields.includes('codigo_postal')">
                            Requerido
                        </template>
                    </vs-input>
                </vs-col>
                <vs-col class="inputTitulo" sm="12" lg="4">
                    <label>Uso de CFDI *</label>
                    <vs-select
                        filter
                        class="pt-0"
                        placeholder="Uso de CFDI" 
                        v-model="info.uso_cfdi"
                        :key="cfdiId" 
                    >
                        <vs-option v-for="(cfdi, i) in optCfdi" :key="i" :label="cfdi.text" :value="cfdi.id">
                            {{cfdi.text}}
                        </vs-option>
                        <template #message-danger v-if="errorFields.includes('cfdi')">
                            Requerido
                        </template>
                    </vs-select>
                </vs-col>
                <vs-col w="12" class="mt-4 d-flex">
                    <div @click="postEliminarDatosFiscales()">
                        <div class="botonCancelar">
                            Eliminar datos
                        </div>
                    </div>
                    <vs-button
                        success
                        type="submit"
                        class="ml-auto"
                    >
                        Guardar
                    </vs-button>
                </vs-col>
            </vs-row>
        </form>
    </div>
</template>
<script>
import alumnos from '../../../../api/requests/alumno'
export default {
    props: [
        'general',
        'personaRol',
        'proceso'
    ],
    data(){
        return{
            info: {
                rfc: '',
                razon_social: '',
                correo_fiscal: '',
                uso_cfdi: '',
                codigo_postal: '',
                regimen_fiscal: '',
                id: '',
            },
            regimenes: [],
            optCfdi:[
                {'id': 'G01', 'text': 'Adquisición de Mercancías'},
                {'id': 'G02', 'text': 'Devoluciones, Descuentos o Bonificaciones'},
                {'id': 'G03', 'text': 'Gastos en General'},
                {'id': 'I01', 'text': 'Construcciones'},
                {'id': 'I02', 'text': 'Mobiliario y Equipo de Oficina por Inversiones'},
                {'id': 'I03', 'text': 'Equipo de Transporte'},
                {'id': 'I04', 'text': 'Equipo de Cómputo y Accesorios'},
                {'id': 'I05', 'text': 'Dados, Troqueles, Moldes, Matrices y Herramental'},
                {'id': 'I06', 'text': 'Comunicaciones Telefónicas'},
                {'id': 'I07', 'text': 'Comunicaciones Satelitales'},
                {'id': 'I08', 'text': 'Otra Maquinaria y Equipo'},
                {'id': 'D01', 'text': 'Honorarios Médicos, Dentales y Gastos Hospitalarios'},
                {'id': 'D02', 'text': 'Gastos Médicos por Incapacidad o Discapacidad'},
                {'id': 'D03', 'text': 'Gastos Funerales'},
                {'id': 'D04', 'text': 'Donativos'},
                {'id': 'D05', 'text': 'Intereses Reales Efectivamente Pagados por Créditos Hipotecarios (Casa Habitación)'},
                {'id': 'D06', 'text': 'Aportaciones Voluntarias al SAR'},
                {'id': 'D07', 'text': 'Primas por Seguros de Gastos Médicos'},
                {'id': 'D08', 'text': 'Gastos de Transportación Escolar Obligatoria'},
                {'id': 'D09', 'text': 'Depósitos en Cuentas para el Ahorro, Primas que tengan como Base Planes de Pensiones'},
                {'id': 'D10', 'text': 'Pagos por Servicios Educativos (Colegiaturas)'},
                {'id': 'S01', 'text': 'Sin efectos fiscales'},
                {'id': 'CP01', 'text': 'Pagos'},
                {'id': 'CN01', 'text': 'Nómina'},
            ],
            regimenId: (new Date()).getTime(),
            cfdiId: (new Date()).getTime(),
            errorFields: [],
            rfcCaracteres: false,
            fecha_hora: '',
            userModificacion: {}
        }
    },
    methods: {
        getInfo(){
            const vm = this
            if(vm.general.datos.datos_fiscales){
                const regimen_fiscal = vm.general.datos.datos_fiscales.regimen_fiscal == null ? '' : vm.general.datos.datos_fiscales.regimen_fiscal
                let {rfc = '', razon_social = '', correo_fiscal = '', uso_cfdi = '', codigo_postal = '', id = ''} = this.general.datos.datos_fiscales
                Object.assign(this.info, {rfc, razon_social, correo_fiscal, uso_cfdi, codigo_postal, regimen_fiscal, id})
                const fecha_utc = new Date(vm.general.datos.datos_fiscales.updated_at)
                vm.fecha_hora = [fecha_utc.getDate(), fecha_utc.getMonth()+1, fecha_utc.getFullYear()].join('-')+' '+ [fecha_utc.getHours(), fecha_utc.getMinutes(), fecha_utc.getSeconds()].join(':');
                this.userModificacion = vm.general.datos.datos_fiscales.user ? vm.general.datos.datos_fiscales.user : {}
            }
        },
        async getRegimen(){
            try {
                const response = await alumnos.getRegimen()
                this.regimenes = response.data
                this.regimenId = (new Date()).getTime()
                this.getInfo()
            } catch (error) {
                console.log(error)
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.info.rfc){
                this.errorFields.push('rfc')
            }
            if (!this.info.razon_social){
                this.errorFields.push('razon_social')
            }
            if (!this.info.correo_fiscal){
                this.errorFields.push('correo_fiscal')
            }
            if (!this.info.uso_cfdi){
                this.errorFields.push('uso_cfdi')
            }
            if (!this.info.codigo_postal){
                this.errorFields.push('codigo_postal')
            }
            if (!this.info.regimen_fiscal){
                this.errorFields.push('regimen_fiscal')
            }
            if (!this.errorFields.length){
                
                const params = {
                    tipo: this.general.datos.tipo,
                    rfc: this.info.rfc,
                    razon_social: this.info.razon_social,
                    correo_fiscal: this.info.correo_fiscal,
                    uso_cfdi: this.info.uso_cfdi,
                    codigo_postal: this.info.codigo_postal,
                    regimen_fiscal: this.info.regimen_fiscal
                }
                return params
            } else {
                return null
            }
        },
        tranformarMayusculas(){
            this.info.rfc = this.info.rfc.toUpperCase()
        },
        getRfc(rfc){
            const re = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{3})$/
            const carecter =  re.test(rfc)
            if(!carecter){
                this.rfcCaracteres = true
            }else{
                this.rfcCaracteres = false
            }
        },
        async postDatosFiscales(){
            if(this.sanityForm() && !this.rfcCaracteres){
                const loading = this.$vs.loading()
                try{
                    const {data: response} = await alumnos.postDatosFiscales(this.general.datos.persona_id, this.sanityForm())
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        icon: '<i class="fas fa-check"></i>',
                        title: 'Operación éxitosa',
                        text: response.message
                    })
                    loading.close()
                    this.$emit('refreshComponent', this.general.datos.persona_id, this.proceso)
                }catch(error){
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Algo salió mal',
                        text: 'Favor de poner en contacto con el administrador'
                    })
                }
            }
        },
        async postEliminarDatosFiscales(){
            const loading = this.$vs.loading()
            try{
                const {data: response} = await alumnos.postEliminarDatosFiscales(this.info.id)
                loading.close()
                this.$emit('refreshComponent', this.general.datos.persona_id, this.proceso)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    icon: '<i class="fas fa-check"></i>',
                    title: 'Operación éxitosa',
                    text: response.message
                })
            }catch{
                    loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Operación éxitosa',
                    text: response.message
                })
            }
        }
    },
    watch:{
        general(){
            this.getRegimen()
        }
    }
}
</script>
<style>
.lineTitulo{
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 3%;
}
.inputTitulo label{
    padding-left: 11px;
    margin-top: 2%;
}
</style>
